import { render, staticRenderFns } from "./FormularioOferta.vue?vue&type=template&id=788fa212"
import script from "./FormularioOferta.vue?vue&type=script&lang=js"
export * from "./FormularioOferta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports